import { Area } from "react-easy-crop";
import { createImage } from "./createImage";

export const getCroppedImg = async (
  imageSrc: string,
  crop: Area,
): Promise<string> => {
  try {
    const image = await createImage(imageSrc);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    if (!ctx) throw new Error("Failed to get canvas context");

    canvas.width = crop.width;
    canvas.height = crop.height;

    // Rysowanie na kanwie, by wykonać operację kadrowania
    ctx.drawImage(
      image,
      crop.x,
      crop.y,
      crop.width,
      crop.height,
      0,
      0,
      crop.width,
      crop.height,
    );

    // Zwrócenie wynikowego obrazu w formacie Base64
    const dataUrl = canvas.toDataURL("image/jpeg");
    console.log("Cropped Image Data URL:", dataUrl);

    return dataUrl;
  } catch (error) {
    console.error("Error cropping the image:", error);
    throw new Error("Image cropping failed");
  }
};

export default getCroppedImg;
